<ng-container *transloco="let t">
  <ng-container [formGroup]="editForm">
    <ng-container formGroupName="config">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="subject">{{t('alert-mail-edit.subject')}}</mat-label>
            <input type="text" matInput name="subject" formControlName="subject" />
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="message">{{t('alert-mail-edit.message')}}</mat-label>
            <textarea matInput name="message" formControlName="message"></textarea>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-label>{{t('alert-mail-edit.explicitAddresses')}}</mat-label>
          <ul>
            <li *ngFor="let addr of explicitAddresses$ | async ">{{addr}} <mat-icon class="pointer" color="warn"
                *ngIf="mode === 'edit'" (click)="removeExplicitAddress(addr)">delete</mat-icon>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" *ngIf="mode === 'edit'">
        <div class="col-12">
          <mat-form-field class="w-100" appearance="fill">
            <input matInput type="email" #addrInput
              (keyup.enter)="addExplicitAddress(addrInput.value); addrInput.value = ''" />
            <mat-label>{{ t('alert-mail-edit.addExplicitAddress')}}</mat-label>
            <a class="pointer" matSuffix mat-button mat-icon-button
              (click)="addExplicitAddress(addrInput.value); addrInput.value = ''" type="button">
              <mat-icon>add</mat-icon>
            </a>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<data-collector-edit label="{{'alert-mail-edit.fromPrevStepsAddresses' | transloco}}" [mode]="mode"
  [currentProcedureId]="step?.procedureId" [currentProcedureStepId]="step?.id"
  [configs]="(fromPrevStepsAddresses$ | async) || []" (configAdded)="addFromPrevStepsAddress($event)"
  (configRemoved)="removeFromPrevStepsAddress($event)">
</data-collector-edit>

<data-collector-edit label="{{'alert-mail-edit.attachmentsFromPrevSteps' | transloco}}" [mode]="mode"
  [currentProcedureId]="step?.procedureId" [currentProcedureStepId]="step?.id"
  [configs]="(attachmentsFromPrevSteps$ | async) || []" (configAdded)="addAttachmentFromPrevSteps($event)"
  (configRemoved)="removeAttachmentFromPrevSteps($event)">
</data-collector-edit>
